import React from "react";

function PrivacyPolicy() {
  return (
    <div className="flex justify-center pb-[50px] lg:px-[20px] ">
      <div className="w-[90vw] sm:w-[600px] md:w-[700px] lg:w-[800px] lg:mr-[300px] break-normal">
        <div className="pt-[50px] lg:pt-[100px] pb-[20px]">
          <h className="text-[40px] font-semibold">Privacy Policy</h>
        </div>
        <div>
          <p className="flex flex-col gap-[20px] text-[17px] font-[sans-serif] text-[#838f9d]">
            <span>
              Modelopedia.com is sensitive to privacy issues on the Internet. We
              believe it is important you know how we treat the information
              about you we receive via the Internet. In general, you can visit
              Modelopedia.com on the World Wide Web without telling us who you
              are or revealing any information about yourself.
            </span>
            <span>
              Our web servers collect the domain names, not the e-mail
              addresses, of visitors. This information may be aggregated on a
              "no names" basis to measure the number of visits, average time
              spent on the site, pages viewed, etc. Modelopedia.com uses this
              information to measure the use of our site and to improve the
              content of our site. There are times, however, when we may need
              information from you, such as your name and address. When
              information is needed, we will let you know at the time of
              collection, how we will use the personal information. Usually, the
              personal information we collect is used only by us to respond to
              your inquiry, process an order or allow you to access specific
              account information. Modelopedia.com makes every effort to
              maintain the security of its network and the data we collect. Any
              data that is stored on Modelopedia.com server is treated as
              proprietary and confidential and is not available to the public.
            </span>
            <span>
              Modelopedia.com has a strict internal security policy with respect
              to the confidentiality of customer and other data, limiting access
              only to those employees who have a need to know such information
              for the purpose of effectively delivering Modelopedia.com products
              and services. Modelopedia.com is very sensitive to the issue of
              children's privacy and makes every effort to protect the privacy
              of children surfing the web.
            </span>
            <span>
              If you believe your child has provided Modelopedia.com with
              personally-identifiable data, or registered at one of
              Modelopedia.com web sites, and you would like to have them
              removed, please contact sales@Modelopedia.com. At times we conduct
              on-line surveys to better understand the needs and profile of our
              visitors. When we conduct a survey, we will try to let you know
              how we will use the information at the time we collect information
              from you on the Internet. Modelopedia.com's website may contain
              links to other Web sites. While we try to link only to sites that
              share our high standards and respect for privacy, we are not
              responsible for the content or the privacy practices employed by
              other sites. For more information or if you have questions or
              concerns regarding Modelopedia.com's Privacy Statement, please
              send an e-mail to sales@Modelopedia.com.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
